<div class="hbox pos-rel font-noto">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="tw-bg-black tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]">
        <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="backHome()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
        </div>
        <span class="tw-font-body tw-font-bold tw-text-300 tw-text-white" i18n="@@wallet">Cure wallet</span>
      </div>
    </div>
    <div class="flex-content bg-app">
      <header class="tw-bg-grid-layout tw-bg-repeat-x tw-bg-top">
        <div class="title" i18n="@@walletBalance">Current balance</div>
        <div class="balance bdr-btm">
          <div class="num tw-ml-0">₹</div>
          <div class="num tw-ml-0">{{walletBalance}}</div>
        </div>
        <div class="total">
          <span i18n="@@earnedSoFar">Total Cure Cash earned :</span><span>{{totalEarned}}</span>
        </div>
        <div class="links">
          <div class="w50" i18n="@@cureskinCashHistory" (click)='navigateTo("/user/wallet/transactions")'>
            Cure Cash History
          </div>
          <div class="v-separator w50" i18n="@@userWalletFaqs" (click)='navigateTo("/user/refer?tab=faq")'>FAQs</div>
        </div>
      </header>
      <section>
        @if (loading) {
          <loading class="pos-abs vh-center"></loading>
        }
        <div class="toolbar">
          <toolbar-tabs [data]="tabData" (tabSelected)="tabChange($event)" [floatOnScroll]="false">
            <tab1 i18n="@@rewards">Rewards</tab1>
            <tab2 i18n="@@earn">Earn more</tab2>
            <tab3 i18n="@@redeem">Redeem</tab3>
          </toolbar-tabs>
        </div>
        @if (!loading) {
          <div class="flex-grow pos-rel">
            @if (selectedTabIndex === 0) {
              <div class="rewardTab">
                @if (!allEarnedCashOfUser.length) {
                  <div class="centerA empty-hint empty-icon" i18n="@@noRewards">
              No Rewards Available
            </div>
                }
                @for (item of allEarnedCashOfUser; track item; let i = $index) {
                  <div class="card" #cardItem="">
                    <div class="content">
                      @if (!item.isClaimed) {
                        <div class="scratched">
                          <div class="fontS2" i18n="@@youHaveEarned">You have earned</div>
                          <div class="flex mT15">
                            <div class="bold fontL4">₹</div>
                            <div class="bold fontL4">{{item.amount}}</div>
                          </div>
                          @if (item.referenceType) {
                            <div class="source tw-capitalize">
                              Source : {{item.referenceType}}
                            </div>
                          }
                          <img class="paper" src="https://cdn.cureskin.com/app/img/paper-purple.png" />
                        </div>
                      }
                      @if (!item.isClaimed) {
                        <div class="unscratched" [ngClass]="{ 'purple': i%2 === 0, 'yellow': i%2 === 1 }">
                          <img src="https://cdn.cureskin.com/app/img/heart-trans.svg" />
                          <div class="text" i18n="@@scratchToWin">
                    Scratch to win between 5 - 500
                  </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (selectedTabIndex === 1) {
              <div class="earnTab">
                <div class="earnInfo">
                  <div class="dt" (click)='navigateTo("/user/refer")'>
                    <div class="dtc">
                      <img class="refer" src="https://cdn.cureskin.com/app/img/earn-couple.png" />
                    </div>
                    <div class="dtc v-mid">
                      <div class="refer" i18n="@@referAndEarn">Refer & Earn</div>
                      <div class="invite tw-normal-case" i18n="@@inviteFriends">
                    Invite your friend to earn more Cure Cash
                  </div>
                      <div class="know clr-green tw-text-teal-600" i18n="@@knowMore">Know More</div>
                    </div>
                  </div>
                </div>
                <div class="share">
                  <em></em>
                  <div i18n="@@earnOnSuccessRef">
                <div class="cash">
                  <span>Earn</span><span>&nbsp;₹</span><span> {{referralCashValue}}</span>
                </div>
                <div class="fontL1 tw-normal-case">
                  on every successful referral
                </div>
              </div>
                  <div class="code" (click)="copyText()">
                    <input id="referralCode" value="REFERRAL CODE - {{user.id}}" readonly="readonly" />
                  </div>
                  <div class="btn tw-bg-teal-600 tw-capitalize tw-tracking-normal" (click)="shareApp()" i18n="@@share">Share</div>
                </div>
              </div>
            }
            @if (selectedTabIndex === 2 && isOrderDelivered) {
              <div class="redeemTab">
                @if (!products.length) {
                  <div class="centerA empty-hint empty-icon" i18n="@@noRewardsToRedeem">
              No Rewards To Redeem
            </div>
                }
                @if (products.length) {
                  <div class="products">
                    <div class="title" i18n="@@productsToOrder">
                Products You May Like To Order
              </div>
                    <div class="cardHolder">
                      <div class="dt anim-group">
                        @for (item of products; track item) {
                          @if (item.price !== 0) {
                            <div class="card anim-fadeIn" (click)="buyProduct(item)">
                              <div class="img">
                                <img [src]="getImageSrc(item)" align="middle" />
                              </div>
                              <div class="detail">
                                <div class="name">{{item.title}}</div>
                                <div class="price">₹{{item.price}}</div>
                              </div>
                              <div
                                class="tw-h-8 tw-flex tw-items-center tw-text-center tw-justify-center tw-gap-1 tw-text-white tw-font-bold tw-text-200 tw-mx-4 tw-bg-teal-600 tw-rounded-2 tw-my-2"
                                >
                                <span i18n="@@addToCart">Add to Cart</span>
                              </div>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </section>
    </div>
  </div>
</div>
@if (scratchCard) {
  <pop-up id="scratchCardPopup" [show]="true" (close)="closeScratch()" bg="rgba(255, 255, 255, 0)">
    <div class="scratch-zoom" id="holder" (click)="stopPropagation($event)">
      <div class="earned">
        <div class="fontS1" i18n="@@youHaveEarned">You have earned</div>
        <div class="df mT15">
          <img src="https://cdn.cureskin.com/app/img/heart-purple.svg" />
          <div class="fw-600 fontL4 mL10">{{scratchCard.amount}}</div>
        </div>
        @if (scratchCard.source) {
          <div class="source">
            Source : {{scratchCard.source}}
          </div>
        }
        <img class="paper" [style.visibility]='scratchCard.scratched ? "visible" : "hidden"' src="https://cdn.cureskin.com/app/img/paper-purple.png" />
      </div>
      <canvas #canvasCard=""></canvas>
    </div>
    <div class="note" i18n="@@scratchNote">
    Swipe back & forth to see what you’ve won!
  </div>
  </pop-up>
  }@if (claimCashPopup?.show) {
  <pop-up [show]="true" (close)="claimCashPopup.show = false" [class]="'bdr-rad-5'">
    @if (!claimCashPopup.isClaimed) {
      <div class="claim-cash">
        <div class="fw-500 fontL2 mB15" i18n="@@enterTheCouponCode">
      Enter the coupon code
    </div>
        <input class="primary mB30 text-center fontL2 fw-600" #cashCode="" autofocus="autofocus" /><cs-button [class]="'primary btn-xs w100'" (callback)="applyCouponAndClaimCash(cashCode.value)" [disabled]="!cashCode.value" [loading]="claimCashPopup.inProgress"><cs-button-text i18n="@@apply">Apply</cs-button-text></cs-button>
      </div>
    }
    @if (claimCashPopup.isClaimed) {
      <div class="claim-cash bg-paper">
        <div class="fw-600 fontL3 clr-primary ls-1" i18n="@@congratulations">Congratulations!</div>
        <div class="fontL2 fw-500 mTB30" i18n="@@youHaveGotCashAdded">
      You have got {{claimCashPopup.amount}} in your Cure wallet.
    </div>
        <cs-button [class]="'primary btn-xs'" (callback)="shopCureskinCash()"><cs-button-text i18n="@@shopNow">Shop Now</cs-button-text></cs-button>
      </div>
    }
  </pop-up>
}
